import Vue from 'vue'
import Vuex from 'vuex'
import { wxWorkAuthorizationLogin } from '@/api/login'
import { A_ACCESS_TOKEN, A_TENANT_ID } from '@/store/mutation-types'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
    // 微信认证登陆
    WxWorkAuthorizationLogin ({ commit }, authorizationInfo) {
      return new Promise((resolve, reject) => {
        wxWorkAuthorizationLogin(authorizationInfo).then(response => {
          const result = response.result
          // 记住当前用户1天
          Vue.ls.set(A_ACCESS_TOKEN, result.accessToken, 24 * 60 * 60 * 1000)
          Vue.ls.set(A_TENANT_ID, 3, 24 * 60 * 60 * 1000)
          resolve({
            aTenantId: 3,
            aToken: result.accessToken
          })
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  modules: {
  }
})
